// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails"
import "../controllers"
// import "peity-vanilla-rails"
import '../sortable.js'
import '../direct_upload.js'
import {startIcons} from '../import_lucid.js'
import LocalTime from 'local-time'

import "trix"
import "@rails/actiontext"

LocalTime.start()
document.addEventListener("turbo:morph", () => {
  LocalTime.run()
})

document.addEventListener("turbo:render", () => {
  startIcons()
})

// Lazy turbo-frames (src=) load their HTML after turbo:render has already fired and
// don't emit a stream event, so their <i data-lucide> stay un-rendered. Re-init icons
// scoped to the frame when it finishes loading (e.g. the builder's report_section_schema panel).
document.addEventListener("turbo:frame-load", (event) => {
  startIcons(event.target)
})

// Re-initialize icons after Turbo Stream updates (ActionCable broadcasts, form responses)
document.addEventListener("turbo:before-stream-render", (event) => {
  const originalRender = event.detail.render
  event.detail.render = function (streamElement) {
    originalRender(streamElement)
    startIcons()
  }
})

startIcons()

import * as ActiveStorage from "@rails/activestorage"

ActiveStorage.start()


window.styleAmt = function (amt) {
  if (parseFloat(amt) === 0) {
    return displayZeroAs()
  }
  if (parseFloat(amt) < 0) {
    return `(${new Intl.NumberFormat(currentUserCommaStyle(), {minimumFractionDigits: precision()}).format(roundAmount(amt))})`
  } else {
    return new Intl.NumberFormat(currentUserCommaStyle(), {minimumFractionDigits: precision()}).format(roundAmount(amt))
  }
}

function precision() {
  if (currentUserPrecision() === "") {
    if (currentUserRoundPreference() === 'units') {
      return 0
    } else {
      return 2
    }
  } else {
    return currentUserPrecision()
  }
}

function currentUserRoundPreference() {
  return document.querySelector('meta[name="userRoundPreference"]').content || 'units'
}

function currentUserPrecision() {
  return document.querySelector('meta[name="userPrecision"]').content || ''
}

function currentUserCommaStyle() {
  var style = document.querySelector('meta[name="userCommaStyle"]').content || 'indian'
  if (style === 'western') {
    return 'en-US'
  } else {
    return 'en-IN'
  }
}

function roundAmount(amt) {
  var preference = currentUserRoundPreference()
  var rounding = {
    units: 1,
    thousands: 1000,
    lakhs: 100000,
    millions: 1000000,
    crores: 10000000
  }
  return parseFloat((Math.abs(amt) / rounding[preference]).toFixed(2))
}

function displayZeroAs() {
  var meta = document.querySelector('meta[name="displayZeroAs"]')
  if (meta !== undefined && meta.content === 'zero') {
    return '0'
  } else {
    return '-'
  }
}

Turbo.StreamActions.update_url = function () {
  const url = this.getAttribute("url")
  if (url) {
    history.replaceState({}, '', url)
  }
}

Turbo.StreamActions.change_location = function () {
  const url = this.getAttribute("url")
  if (url) {
    window.location.href = url
  }
}

Turbo.StreamActions.update_url = function () {
  const url = this.getAttribute("url")
  // A chat driven from the story-page PharOS panel (e.g. a main chat reopened from its History)
  // must not swap the story page's URL for /chats.
  if (url && !document.getElementById("pharos_panel_main")) {
    window.history.replaceState(window.history.state, "", url)
  }
}

// <%= turbo_stream_action_tag 'change_location', url: chats_path(organization_slug: Current.organization_slug, chat_id: @chat) %>

// turbo_stream_action_tag :add_class, target: 'form_overlay', classes: "hidden"
// ActionCable.server.broadcast(
//         "stream_name",
//         %(<turbo-stream classes="hidden" action="add_class" target="form_overlay"><template></template></turbo-stream>)
//       )

Turbo.StreamActions.add_class = function () {
  const classes = this.getAttribute("classes")?.split(" ").filter(Boolean);
  if (classes?.length) {
    this.targetElements.forEach((target) => {
      target.classList.add(...classes);
    });
  }
};

Turbo.StreamActions.remove_class = function () {
  const classes = this.getAttribute("classes")?.split(" ").filter(Boolean);
  if (classes?.length) {
    this.targetElements.forEach((target) => {
      target.classList.remove(...classes);
    });
  }
};

Turbo.StreamActions.toggle_class = function () {
  const classes = this.getAttribute("classes")?.split(" ").filter(Boolean);
  if (classes?.length) {
    this.targetElements.forEach((target) => {
      classes.forEach((klass) => target.classList.toggle(klass));
    });
  }
};

// <%= turbo_stream.action :add_class, target: "my_element", classes: "is-active highlighted" %>

// <%= turbo_stream.action :remove_class, targets: ".cards", classes: "is-loading" %>

// <%= turbo_stream.action :toggle_class, target: "menu", classes: "is-open" %>
